import GameImage1 from '../assets/images/games-1.webp';
import GameImage2 from '../assets/images/games-2.webp';
import GameImage3 from '../assets/images/stl.webp';
import TwoDImage from '../assets/images/games-4.webp';
import Pick3Image from '../assets/images/PICK3.webp';
import Last2Image from '../assets/images/LAST-2.webp';
import Last3Image from '../assets/images/LAST3.webp';
import STLMISORImage from '../assets/images/STLMISOR.webp';
import STLCDOImage from '../assets/images/STLCDO.webp';
import STLBUKIDNONImage from '../assets/images/STLBUKIDNON.webp';
import S2Image from '../assets/images/S2Lotto.webp';
import FourDImage from '../assets/images/4D.png';
import SixDImage from '../assets/images/6D.jpeg';

export const getGameImage = (settingsId) => {
  const imageMap = {
    '3D': GameImage1, // 3D
    '2D': TwoDImage, // 2D
    STL: GameImage3, // STL
    STLMISOR: STLMISORImage, // STLMISOR
    STLCDO: STLCDOImage, // STLCDO
    STLBUKIDNON: STLBUKIDNONImage, // STLBUKIDNON
    PICK3: Pick3Image, // PICK 3
    LAST2: Last2Image, // LAST 2
    LAST3: Last3Image, // LAST 3
    S2: S2Image, // S2
    '4D': FourDImage, // 4D
    '6D': SixDImage, // 6D
  };
  return imageMap[settingsId] || GameImage1;
};

export default getGameImage;
